import { execOnLoad, formatPrice } from '@general/helpers';
import Swiper from 'swiper';
import { EffectFade, Navigation, Pagination } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import { initProductForm } from '@components/product';
import { openMinicart } from '@components/minicart';
import breakpoints from 'breakpoints';
import { throttle } from 'lodash';
import { addToWishlist, getWishlist, deleteFromWishlist } from '@components/wishlist';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductTile = (context) => {
  const snippetContainer = context.classList.contains('.product-tile__container')
    ? context
    : context.closest('.product-tile__container');
  if (!snippetContainer || snippetContainer.classList.contains('product-tile__container--initialized')) return;

  const swiperWrapper = snippetContainer.querySelector(
    '.product-tile__gallery .product-tile__gallery--desktop .swiper-wrapper',
  );
  if (swiperWrapper && swiperWrapper.querySelectorAll('.swiper-slide').length > 1) {
    const swiperContainer = snippetContainer.querySelector('.product-tile__gallery--desktop');
    const pagination = snippetContainer.querySelector('.product-tile__gallery-pagination');

    let effect = 'fade';
    if (window.innerWidth <= parseInt(breakpoints.lg)) effect = 'slide';

    const options = {
      modules: [EffectFade, Navigation, ...(pagination ? [Pagination] : [])],
      crossFade: true,
      effect,
      navigation: {
        prevEl: snippetContainer?.querySelector('.product-tile__gallery-arrow--left'),
        nextEl: snippetContainer?.querySelector('.product-tile__gallery-arrow--right'),
      },
      ...(pagination
        ? {
            pagination: {
              el: pagination,
            },
          }
        : {}),
    };
    var autoChange = true;
    var changeEnter = false;
    var changeLeave = false;
    const swiper = new Swiper(swiperContainer, options);

    snippetContainer.querySelector('.product-tile__gallery')?.addEventListener('mouseenter', () => {
      if (window.innerWidth <= parseInt(breakpoints.lg) || !autoChange) return;
      changeEnter = true;
      swiper.slideTo(1);
    });

    snippetContainer.querySelector('.product-tile__gallery')?.addEventListener('mouseleave', () => {
      if (window.innerWidth <= parseInt(breakpoints.lg) || !autoChange) return;
      changeLeave = true;
      swiper.slideTo(0);
    });

    swiper.on('slideChangeTransitionStart', () => {
      if (!changeEnter && !changeLeave) {
        autoChange = false;
        return;
      }
      if (changeEnter) changeEnter = false;
      if (changeLeave) changeLeave = false;
    });
  }

  // const swiperWrapperMob = snippetContainer.querySelector(
  //   '.product-tile__gallery .product-tile__gallery--mobile .swiper-wrapper',
  // );

  // if (
  //   swiperWrapperMob &&
  //   swiperWrapperMob.querySelectorAll('.swiper-slide').length > 1
  // ) {
  //   const swiperContainerMobile = snippetContainer.querySelector(
  //     '.product-tile__gallery--mobile',
  //   );

  //   const pagination = snippetContainer.querySelector(
  //     '.product-tile__gallery-pagination',
  //   );
  //   const options = {
  //     modules: [EffectFade, Navigation, ...(pagination ? [Pagination] : [])],
  //     effect: 'slide',
  //     navigation: {
  //       prevEl: swiperContainerMobile?.querySelector(
  //         '.product-tile__gallery-arrow--left',
  //       ),
  //       nextEl: swiperContainerMobile?.querySelector(
  //         '.product-tile__gallery-arrow--right',
  //       ),
  //     },
  //     ...(pagination
  //       ? {
  //           pagination: {
  //             el: pagination,
  //           },
  //         }
  //       : {}),
  //   };
  //   let autoChange = true;
  //   let changeEnter = false;
  //   let changeLeave = false;
  //   const swiperMob = new Swiper(swiperContainerMobile, options);
  //   swiperContainerMobile?.addEventListener('mouseenter', () => {
  //     if (window.innerWidth <= parseInt(breakpoints.lg) || !autoChange) return;
  //     changeEnter = true;
  //     swiperMob.slideTo(1);
  //   });

  //   swiperContainerMobile?.addEventListener('mouseleave', () => {
  //     if (window.innerWidth <= parseInt(breakpoints.lg) || !autoChange) return;
  //     changeLeave = true;
  //     swiperMob.slideTo(0);
  //   });

  //   swiperMob.on('slideChangeTransitionStart', () => {
  //     if (!changeEnter && !changeLeave) {
  //       autoChange = false;
  //       return;
  //     }
  //     if (changeEnter) changeEnter = false;
  //     if (changeLeave) changeLeave = false;
  //   });
  // }

  const toggleBtn = snippetContainer.querySelector('.product-tile__colors-toggle');
  const moreColors = snippetContainer.querySelector('.product-tile__colors--more');

  if (toggleBtn && moreColors) {
    toggleBtn.addEventListener('click', () => {
      moreColors.classList.remove('hidden');
      toggleBtn.style.display = 'none';
    });

    toggleBtn.addEventListener('keypress', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        toggleBtn.click();
      }
    });
  }

  const quickBuy = snippetContainer.querySelector('.product-tile__quick-buy');
  const form = snippetContainer.querySelector('.product-tile__form');
  const wishlistButton = snippetContainer.querySelector('[data-wishlist-btn]');
  if (quickBuy && form)
    initProductForm({
      form,
      callbacks: {
        afterVariantChange: async ({ variant, product }) => {
          if (wishlistButton) {
            wishlistButton.dataset.wishlistVariantId = variant?.id;
            wishlistButton.dataset.wishlistPrice = formatPrice({
              value: variant?.price ?? 0,
            });
            wishlistButton.dataset.wishlistCompareAtPrice = variant?.compare_at_price
              ? formatPrice({
                  value: variant?.compare_at_price,
                })
              : '';

            const wishlist = await getWishlist();
            const wishlistProduct = wishlist?.listcontents?.find(
              (addedProduct) => addedProduct.epi == variant.id && addedProduct.empi == product.id,
            );
            wishlistButton.dataset.wishlistStatus = wishlistProduct ? 'active' : 'inactive';
          }
        },
        afterSubmit: () => openMinicart(true),
      },
    });

  snippetContainer.classList.add('product-tile__container--initialized');

  if (wishlistButton) {
    const toggleLoading = throttle(() => {
      wishlistButton.classList.toggle('loading');
    }, 500);
    wishlistButton.addEventListener('click', async (e) => {
      e.preventDefault();
      toggleLoading();
      const variantID = wishlistButton?.dataset?.wishlistVariantId;
      const masterID = wishlistButton?.dataset?.wishlistProductId;
      const productURL = wishlistButton?.dataset?.wishlistProductUrl;
      const price = wishlistButton?.dataset?.wishlistPrice;
      const compareAtPrice = wishlistButton?.dataset?.wishlistCompareAtPrice;

      if (wishlistButton?.dataset?.wishlistStatus === 'active') {
        await deleteFromWishlist({ variantID, masterID, productURL });
        wishlistButton.dataset.wishlistStatus = 'inactive';
      } else {
        await addToWishlist({
          variantID,
          masterID,
          productURL,
          compareAtPrice,
          price,
        });
        wishlistButton.dataset.wishlistStatus = 'active';
      }
      toggleLoading();
    });
  }
};

execOnLoad(window.dAgency.initProductTile, '.product-tile__container');
